import React from 'react';
import './Footer.css';

const Footer = () => <div className="footer text-center">Trevor Johnson</div>;

export default Footer;
